import React, { useState, useRef, useEffect } from 'react';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import { Smile } from 'lucide-react';
import { Button } from './ui/button';

const EmojiPicker = ({ onEmojiSelect, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const pickerRef = useRef(null);
  const buttonRef = useRef(null);

  // Close picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pickerRef.current && 
        !pickerRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleEmojiSelect = (emoji) => {
    onEmojiSelect(emoji.native);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <Button
        ref={buttonRef}
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
        className="rounded-full h-10 w-10 bg-white hover:bg-gray-50 text-gray-600 flex-shrink-0 shadow-sm"
        data-testid="emoji-picker-btn"
      >
        <Smile className="h-5 w-5" />
      </Button>
      
      {isOpen && (
        <div 
          ref={pickerRef}
          className="absolute bottom-12 left-0 z-50 shadow-2xl rounded-xl overflow-hidden animate-in fade-in slide-in-from-bottom-2 duration-200"
          style={{ maxWidth: 'calc(100vw - 32px)' }}
        >
          <Picker
            data={data}
            onEmojiSelect={handleEmojiSelect}
            theme="light"
            previewPosition="none"
            skinTonePosition="search"
            maxFrequentRows={2}
            perLine={7}
            emojiSize={22}
            emojiButtonSize={30}
            navPosition="bottom"
            searchPosition="sticky"
          />
        </div>
      )}
    </div>
  );
};

export default EmojiPicker;
